import { PointCounter } from "./point-counter";

export class FixedPointCounter extends PointCounter {
  // ppmm: pixels per mm, plotSize: { width: 0, height: 0}, windowSize: { width: 0, height: 0 }
  constructor(settings) {
    super(settings);
  }

  calculatePointCount() {
    return this.settings.pointCount;
  }
}
